var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.theme},[_c('router-view'),_c('div',{staticStyle:{"width":"100%","height":"100%","background-color":"var(--deepBg)","position":"absolute","left":"0","top":"0","z-index":"-99"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }